import { useRecordContext } from "react-admin";
import { useEffect, useState } from 'react';
import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from 'axios';
import inMemoryJWT from '../inMemoryJWT';
import { useNotify, useDataProvider } from 'react-admin';
import { apiBaseUrl, deviceControlApiUrl } from '../config';

const SelectPatch = function () {
    const notify = useNotify();
    const record = useRecordContext();
    const dataProvider = useDataProvider();
    const [patches, setPatches] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [selectedPatchId, setSelectedPatchId] = React.useState('');

    const getDeviceType = () => {
        if (record.model) {
            return record.model;
        }
        if (record.app_ver && record.app_ver.indexOf('-') !== -1) {
            return record.app_ver.split('-')[1];
        }
        return '';
    };

    const deviceType = getDeviceType();
    const params = {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'created_at', order: 'DESC' },
        filter: {}
    };

    if (deviceType) {
        params.filter.device_type = deviceType;
    }

    useEffect(() => {
        dataProvider.getList('patches', params)
            .then(({ data }) => {
                setPatches(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
    }, [dataProvider, deviceType]);

    if (loading) return <span>Loading</span>;
    if (error) return <span>Error</span>;
    if (!patches) return null;

    const handleChange = (event) => {
        setSelectedPatchId(event.target.value);
    };

    const handleClick = () => {
        if (!selectedPatchId) {
            alert("No patch is selected");
            return;
        }

        let ret = window.confirm("Are you sure to patch this device?");
        if (!ret) {
            return;
        }

        const token = inMemoryJWT.getToken();
        if (!token) {
            console.log("No token found");
            return;
        }

        const selectedPatch = patches.find((onePatch) => onePatch._id === selectedPatchId);
        if (!selectedPatch) {
            notify("Selected patch not found", { type: 'error' });
            return;
        }

        const patchUrl = `${apiBaseUrl}/get_patch_script/${selectedPatch.script_name}`;
        const post_data = {
            device_id: record.device_id,
            url: patchUrl,
            md5: selectedPatch.md5sum,
            description: `manual patch: ${selectedPatch.patch_ver || selectedPatch.script_name}`,
        };

        axios.post(deviceControlApiUrl + 'scripting', post_data, {
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            console.log(response);
            notify("Request to Patch Device : " + record.device_id, { type: 'success' });
        }).catch(function (error) {
            notify("Request to Patch Device : " + record.device_id + " failed :" + error, { type: 'error' });
        });
    };

    return (
        <Stack spacing={2} direction="row">
            <Select
                labelId="patch-select-label"
                id="patch-select"
                value={selectedPatchId}
                label="Patch"
                onChange={handleChange}
            >
                {patches.map(onePatch => {
                    const label = onePatch.patch_ver
                        ? `${onePatch.patch_ver} - ${onePatch.description || ''}`.trim()
                        : (onePatch.description || onePatch.script_name);
                    return (
                        <MenuItem key={onePatch._id} value={onePatch._id}>{label}</MenuItem>
                    );
                })}
            </Select>
            <Button variant="contained" onClick={handleClick}>Patch</Button>
        </Stack>
    )
}

export default SelectPatch;
